import {Surgeon, TGet} from '../domain/surgeon.entities';
import {SurgeonGateway} from '../domain/surgeon.gateway';

export class GetUseCase {
    constructor(private gate: SurgeonGateway) {}

    async execute(params: TGet): Promise<Surgeon> {
        return this.gate.get(params);
    }
}
